import { Project } from "../models/project";

const projects: Project[] = [];

projects.push({
  Title: "LinkWorld",
  Description:
    "A link-in-bio platform that turns your socials, shops and streams into a playable world. Pick a character, add your links as blocks, and share your own lnkwrld.com/yourname address.",
  ImagePath: "/images/projects/LinkWorld.png",
  Link: "https://lnkwrld.com/",
});

projects.push({
  Title: "WideOrbit's Programmatic TV / Radio sales platform.",
  Description:
    "A service to help streamline the process of buying and selling media space in TV and Radio.",
  ImagePath: "/images/projects/WideOrbit.png",
  Link: "https://www.wideorbit.com/",
});

projects.push({
  Title: "Microsoft Academic Verification Engine",
  Description: "A service to verify the academic status of a user.",
  ImagePath: "/images/projects/msacademicverify.png",
  Link: "https://www.msacademicverify.com",
});

projects.push({
  Title: "iDevThis",
  Description:
    "A site dedicated to showcasing the many things people have created using Microsoft Technologies.",
  ImagePath: "/images/projects/idevthis.png",
  Link: "http://idevthis.azurewebsites.net/",
});

projects.push({
  Title: "Jobaline",
  Description:
    "A fully customizable recruiting solution to bridge the gap between the hourly worker and the hiring manager. Jobaline is a fully bilingual mobile first platform that promises to help streamline the hiring process for the hourly wages sector.",
  ImagePath: "/images/projects/jobaline.png",
  Link: "https://jobs.jobaline.com",
});

projects.push({
  Title: "Authora",
  Description: "An Enterprise PGP encryption tool.",
  ImagePath: "/images/projects/authora.png",
  Link: "http://authora.com/",
});

projects.push({
  Title: "Fit Friends",
  Description:
    "A service to help compare your heart health to your friends by pulling smart watch data.",
  ImagePath: "/images/projects/FitFriendsSite.png",
  Link: "http://fitbit.robynseverson.com/",
});
projects.push({
  Title: "Send Facts",
  Description:
    "A SMS prank site that sends funny facts via SMS to your friends and records the responses.",
  ImagePath: "/images/projects/SendFactsHome.png",
  Link: "http://senddinofacts.com",
});

projects.push({
  Title: "Meeting Meter",
  Description:
    "A site built to help companies keep track of how much a meeting costs to help re-evaluate who is needed in a meeting.",
  ImagePath: "/images/projects/MeetingMeter.png",
  Link: "http://meetingmeter.net/",
});

projects.push({
  Title: "Weather App",
  Description:
    "A weather app that pulls your geo location then shows the weather forcast for your area.",
  ImagePath: "/images/projects/WeatherGeoApp.png",
  Link: "http://weather.robyn.work/",
});

projects.push({
  Title: "Ice Cream Game",
  Description: "An Ice Cream game featuring yours truly",
  ImagePath: "/images/projects/IceCream.png",
  Link: "http://icecream.wtf/",
});

const getProjects = (): Project[] => {
  return projects;
};

export default getProjects;
